import React, { useState } from 'react';
import { HeaderSort, HEADER_SORT_TYPES } from '@etiquette-ui/dynamic-table-components';
import { getSubcategoriesFromItem, getSubcategoryName } from 'pages/MenuItems/utils/transformers';

const SortSubcategory = ({ applyFilter, filters, globalState, text }) => {
  const translate = globalState.config.translate;
  const selectedLang = globalState.config.selectedLang;
  const subcategories = globalState.config.subcategories;

  const [type, setType] = useState(HEADER_SORT_TYPES.UNORDER);

  const onClick = () => {
    let localType = Array.from(filters.keys()).includes('subcategory') ? type : HEADER_SORT_TYPES.UNORDER;
    switch(localType){
      case HEADER_SORT_TYPES.DESC:
        localType = HEADER_SORT_TYPES.ASC;
        break;
      case HEADER_SORT_TYPES.ASC:
        localType = HEADER_SORT_TYPES.UNORDER;
        break;
      case HEADER_SORT_TYPES.UNORDER: 
        localType = HEADER_SORT_TYPES.DESC;
    }

    setType(localType);

    applyFilter('subcategory', (items) => {
      return items.sort((a, b) => {
        if(localType === HEADER_SORT_TYPES.UNORDER) return 0;

        const catsA = getSubcategoriesFromItem(subcategories, a);
        const A = getSubcategoryName(catsA, translate, selectedLang).toUpperCase();

        const catsB = getSubcategoriesFromItem(subcategories, b);
        const B = getSubcategoryName(catsB, translate, selectedLang).toUpperCase();
        
        if (A < B) {
          return localType===HEADER_SORT_TYPES.ASC ? 1 : -1;
        }
        if (A > B) {
          return localType===HEADER_SORT_TYPES.ASC ? -1 : 1;
        }
      });
    }, {reset: true});
  };

  return <HeaderSort 
    text={text} 
    sortType={type}
    onClick={onClick} 
    style={{ marginLeft: '16px' }}
    enabled={!Array.from(filters.keys()).includes('subcategory')} 
  />;
};

export default SortSubcategory;
